import { Injectable } from '@angular/core';
import { UserDto, UserIdDto, EnterpriseDto, EnterpriseIdDto, MachineV2Dto, MachineIdDto, ImplementV2Dto, ImplementIdDto, ExaAdapterV2Dto, ExaAdapterIdDto, ExaBeaconV2Dto, ExaBeaconIdDto, FieldV2Dto, FieldIdDto, LocationV2Dto, LocationIdDto, GeometryIdDto, EmployeeV2Dto, EmployeeIdDto, EnterpriseCustomerV2Dto, EnterpriseCustomerIdDto } from '../api/exa';


@Injectable({
  providedIn: 'root',
})
export class NameFormattingService {
  private className = 'NameFormattingService';

  static getUserName(user?: UserDto | UserIdDto): string {
    let name = '';
    if (user) {
      if (user.firstName) {
        if (!name) {
          name = '';
        }
        name += user.firstName;
      }
      if (user.lastName) {
        if (!name) {
          name = '';
        } else {
          name += ' ';
        }
        name += user.lastName;
      }
      if (!name && user.username) {
        name = user.username;
      }
    }
    return name;
  }

  static getEnterpriseName(enterprise?: EnterpriseDto | EnterpriseIdDto): string {
    if (enterprise && enterprise.name) {
      return enterprise.name;
    }
    return '';
  }

  static getMachineName(machine?: MachineV2Dto | MachineIdDto, noMakeModelFillOnEmpty?: boolean): string {
    if (machine) {
      if (machine.name && machine.name.trim()) {
        return machine.name;
      } else {
        if (!noMakeModelFillOnEmpty) {
          let name = '';
          if (machine.make) {
            name += machine.make;
          }
          if (machine.model) {
            if (name) {
              name += ' ';
            }
            name += machine.model;
          }
          return name;
        }
      }
    }
    return '';
  }

  static getImplementName(implement?: ImplementV2Dto | ImplementIdDto, noMakeModelFillOnEmpty?: boolean): string {
    if (implement) {
      if (implement.name && implement.name.trim()) {
        return implement.name;
      } else {
        if (!noMakeModelFillOnEmpty) {
          let name = '';
          if (implement.make) {
            name += implement.make;
          }
          if (implement.model) {
            if (name) {
              name += ' ';
            }
            name += implement.model;
          }
          return name;
        }
      }
    }
    return '';
  }

  static getExaAdapterName(adapter?: ExaAdapterV2Dto | ExaAdapterIdDto): string {
    if (adapter && adapter.serial) {
      return adapter.serial;
    }
    return '';
  }

  static getExaBeaconName(beacon?: ExaBeaconV2Dto | ExaBeaconIdDto): string {
    if (beacon && beacon.serial) {
      return beacon.serial;
    }
    return '';
  }

  static getFieldName(field?: FieldV2Dto | FieldIdDto): string {
    if (field && field.name) {
      return field.name;
    }
    return '';
  }

  static getLocationName(location?: LocationV2Dto | LocationIdDto): string {
    if (location && location.name) {
      return location.name;
    }
    return '';
  }

  static getGeometryName(geometry?: GeometryIdDto): string {
    if (geometry) {
      if (geometry.field) {
        return this.getFieldName(geometry.field);
      }
      if (geometry.location) {
        return this.getLocationName(geometry.location);
      }
    }
    return '';
  }

  static getEmployeeName(employeeDto?: EmployeeV2Dto | EmployeeIdDto): string {
    if (employeeDto) {
      if (employeeDto.firstName && employeeDto.lastName) {
        return employeeDto.firstName + ' ' + employeeDto.lastName;
      } else if (employeeDto.firstName) {
        return employeeDto.firstName;
      } else if (employeeDto.lastName) {
        return employeeDto.lastName;
      } else if (employeeDto.username) {
        return employeeDto.username;
      } else {
        return '';
      }
    }
    return '';
  }

  static getEnterpriseCustomerName(customer?: EnterpriseCustomerV2Dto | EnterpriseCustomerIdDto): string {
    if (customer && customer.name) {
      return customer.name;
    }
    return '';
  }
}
